export function getVariantRules(productId, variantId, customerEmail, customerTags) {
    return new Promise((resolve, reject) => {
        const data = new URLSearchParams();
        data.append('id', productId);
        data.append('varient', variantId);
        data.append('shopid', window.shop?.id);
        data.append('shop', window.shop?.domain);
        data.append('customerEmail', customerEmail);
        data.append('customerTags', customerTags.join('|'));
        data.append('languageCode', window.shop.locale || 'en');

        fetch('https://discount2.orichicommerce.com/Customer/GetProduct', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: data
        })
        .then((response) => response.json())
        .then((data) => {
            if (data.Rule.length > 0) {
                resolve(data.Rule[0]);
            }

            reject('No price rules found');
        })
        .catch((error) => {
            reject(error);
        });
    });
}

export function processRule(rule, variant) {
    variant = { ...variant };

    if (rule.Quantity > 0 && rule.Active) {

        let discountAmount = rule.PercentOrPrice;

        if (rule.PriceType === 1) { // percentage
            variant.compare_at_price = variant.price;
            variant.price = Math.round(variant.price * (1 - discountAmount / 100));
        } else if (rule.PriceType === 2) { // fixed price
            variant.compare_at_price = variant.price;
            variant.price = Math.round(variant.price - discountAmount * 100);
        }
    }

    return variant;
}